import React from "react";
import * as MUI from "@material-ui/core";
import cn from "classnames";

import ExportIcon from "../../../../icons/Export";
import XLSIcon from "../../../../icons/office/XLS";
import PPTIcon from "../../../../icons/office/PPT";
import PDFIcon from "../../../../icons/office/PDF";

import { Props } from "./types";
import { useStyles } from "./styles";
import { ExportType } from "../../shared/services/ExportService";

export default ExportButtons;

export function ExportButtons(props: Props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {
    availableButtons = [
      [XLSIcon, "XLSX"],
      [PPTIcon, "PPT"],
      [PDFIcon, "PDF"],
    ],
  } = props;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickFormatExport = (exportType: ExportType) => (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    const { handleClickExport } = props;
    if (handleClickExport) {
      handleClickExport(exportType);
    }

    handleClose();
  };

  const classes = useStyles(props);
  const classNameButton = cn(classes.button, props.className);
  return (
    <>
      <MUI.IconButton className={classNameButton} aria-label="Export" onClick={handleClick}>
        <ExportIcon width="14px" height="14px" />
      </MUI.IconButton>
      <MUI.Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {availableButtons.map(([Icon, label]) => (
          <MUI.MenuItem key={label} onClick={handleClickFormatExport(label)} className={classes.li}>
            <Icon className={classes.icon} />
            {label}
          </MUI.MenuItem>
        ))}
      </MUI.Menu>
    </>
  );
}
